import React, { useState } from 'react';
import CardConfig from '../Components/cardsConfig';
import ModalConfigAS1 from '../Components/modalConfigAS1';
import ModalConfigAS2 from '../Components/modalConfigAS2';
import TitleConfig from '../Components/titleConfig';
import { cardsConfigAS } from '../Utils/constants';

const ConfigAS = () => {
  const [showDecRules, setShowDecRules] = useState(false);
  const [showResRate, setShowResRate] = useState(false);
  const [idConfig, setIdConfig] = useState(null);

  let onCloseModal = idConfig => {
    switch (idConfig) {
      case 0:
        setShowDecRules(false);
        break;
      case 1:
        setShowResRate(false);
        break;
    }
  };

  let openModal = idConfig => {
    switch (idConfig) {
      case 0:
        setShowDecRules(true);
        setIdConfig(idConfig);
        break;
      case 1:
        setShowResRate(true);
        setIdConfig(idConfig);
        break;
    }
  };
  return (
    <div className="configHome">
      <TitleConfig />
      <div className="configHome__container">
        {cardsConfigAS.map((item, key) => <CardConfig item={item} key={key} openModal={openModal} />)}
        <ModalConfigAS1
          close={onCloseModal}
          open={showDecRules}
          idConfig={idConfig}
        />
        <ModalConfigAS2
          close={onCloseModal}
          open={showResRate}
          idConfig={idConfig}
        />
      </div>
    </div>
  );
};

export default ConfigAS;